export const getAppPath = () => {
  let appBaseUrl

  const hostname = window && window.location && window.location.hostname
  const completeUrl = window && window.location.toString()
  console.log('appHostPath.ts - completeUrl: ' + completeUrl)
  console.log('appHostPath.tx - hostname: ' + hostname)

  if (completeUrl.indexOf('calculator/vehicles') !== -1) {
    console.log('appHostPath.ts - We are on calculator/vehicles')
  }

  if (completeUrl.indexOf('clo-secure') !== -1) {
    console.log('appHostPath.ts - We are on secure')
  }

  if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_LOCAL) {
    console.log('We are on localhost')

    appBaseUrl = process.env.REACT_APP_BASE_URL_LOCAL
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_BIKO) {
    console.log('We are on biko')

    appBaseUrl = process.env.REACT_APP_BASE_URL_BIKO
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_BIKOV) {
    console.log('We are on BIKOV')

    appBaseUrl = process.env.REACT_APP_BASE_URL_BIKOV
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_DEVL) {
    console.log('We are on DEVL')

    appBaseUrl = process.env.REACT_APP_BASE_URL_DEVL
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_INTG) {
    console.log('We are on INTG')

    appBaseUrl = process.env.REACT_APP_BASE_URL_INTG
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_PROD) {
    console.log('We are on PROD')

    appBaseUrl = process.env.REACT_APP_BASE_URL_PROD
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_SECURE_DEVL) {
    console.log('We are on SECURE DEVL')

    appBaseUrl = process.env.REACT_APP_BASE_URL_SECURE_DEVL
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_SECURE_INTG) {
    console.log('We are on SECURE INTG')

    appBaseUrl = process.env.REACT_APP_BASE_URL_SECURE_INTG
  } else if (hostname === process.env.REACT_APP_USER_URL_HOSTNAME_SECURE_PROD) {
    console.log('We are on SECURE PROD')

    appBaseUrl = process.env.REACT_APP_BASE_URL_SECURE_PROD
  } else if (hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_DEVL) {
    console.log('We are on DEVL NOWAF')

    appBaseUrl = process.env.REACT_APP_NOWAF_URL_DEVL
  } else if (hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_INTG) {
    console.log('We are on INTG NOWAFt')

    appBaseUrl = process.env.REACT_APP_NOWAF_URL_INTG
  } else if (hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_PROD) {
    console.log('We are on PROD NOWAF')

    appBaseUrl = process.env.REACT_APP_NOWAF_URL_PROD
  } else if (
    hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_SECURE_DEVL
  ) {
    console.log('We are on DEVL SECURE NOWAF')

    appBaseUrl = process.env.REACT_APP_NOWAF_URL_SECURE_DEVL
  } else if (
    hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_SECURE_INTG
  ) {
    console.log('We are on INTG SECURE NOWAF')

    appBaseUrl = process.env.REACT_APP_NOWAF_URL_SECURE_INTG
  } else if (
    hostname === process.env.REACT_APP_NOWAF_URL_HOSTNAME_SECURE_PROD
  ) {
    console.log('We are on PROD SECURE NOWAF')

    appBaseUrl = process.env.REACT_APP_NOWAF_URL_SECURE_PROD
  } else if (hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_DEVL) {
    console.log('We are on DEVL NOWAF')

    appBaseUrl = process.env.REACT_LEGACY_APP_NOWAF_URL_DEVL
  } else if (hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_INTG) {
    console.log('We are on INTG NOWAFt')

    appBaseUrl = process.env.REACT_LEGACY_APP_NOWAF_URL_INTG
  } else if (hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_PROD) {
    console.log('We are on PROD NOWAF')

    appBaseUrl = process.env.REACT_LEGACY_APP_NOWAF_URL_PROD
  } else if (
    hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_SECURE_DEVL
  ) {
    console.log('We are on DEVL SECURE NOWAF')

    appBaseUrl = process.env.REACT_LEGACY_APP_NOWAF_URL_SECURE_DEVL
  } else if (
    hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_SECURE_INTG
  ) {
    console.log('We are on INTG SECURE NOWAF')

    appBaseUrl = process.env.REACT_LEGACY_APP_NOWAF_URL_SECURE_INTG
  } else if (
    hostname === process.env.REACT_LEGACY_APP_NOWAF_URL_HOSTNAME_SECURE_PROD
  ) {
    console.log('We are on PROD SECURE NOWAF')

    appBaseUrl = process.env.REACT_LEGACY_APP_NOWAF_URL_SECURE_PROD
  } else {
    console.log('We are on DEFAULT to PUBLIC_URL: ' + process.env.PUBLIC_URL)

    appBaseUrl = process.env.PUBLIC_URL
  }

  if (appBaseUrl != '/') appBaseUrl = appBaseUrl + '/'

  console.log('appHostPath appBaseURL: ' + appBaseUrl)

  return appBaseUrl
}
